import { getRequestData } from '@/utils';
import get from 'lodash/get';
import {
  qryBindSubsDetailBsnl,
  qryBindSubsRechargeRecently,
  qryBindSubsBBUageCurrent,
} from '@/pages/CustomerAccountProfile/services/customerAccountProfile';

export default {
  namespace: 'customerAccountProfile',
  state: {
    bindSubsDetail: {},
    total: 0,
    pageInfo: {},
    rechargeInfoDtoList: [],
    bbUageInfoDto: {},
  },
  effects: {
    *qryBindSubsDetailBsnl({ payload }, { call, put }) {
      const response = yield call(qryBindSubsDetailBsnl, payload);
      const { bindSubsDetaiDto = {} } = getRequestData(response, false);
      yield put({
        type: 'save',
        payload: { bindSubsDetail: bindSubsDetaiDto },
      });
    },

    *qryBindSubsRechargeRecently({ payload }, { call, put }) {
      const result = yield call(qryBindSubsRechargeRecently, payload);
      const { rechargeInfoDtoList = [], pageDto = {} } = getRequestData(result, false);
      if (get(pageDto, 'pageIndex') === 1) { // 只有第一页返回的总数才是真正的总数
        yield put({
          type: 'save',
          payload: {
            total: pageDto.totalRecord || 0,
          },
        });
      }
      yield put({
        type: 'save',
        payload: { rechargeInfoDtoList: rechargeInfoDtoList || [], pageInfo: pageDto || {} },
      });
    },

    *qryBindSubsBBUageCurrent({ payload }, { call, put }) {
      const result = yield call(qryBindSubsBBUageCurrent, payload);
      const { bbUageInfoDto } = getRequestData(result);
      yield put({
        type: 'save',
        payload: { bbUageInfoDto: bbUageInfoDto || {} },
      });
    },

  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
